module.exports = __webpack_public_path__ + "img/Tilting03.95cb7204.png";